/* ci-native-cart.js — flag-gated native cart drawer (Rebuy Smart Cart bypass).
   Added 2026-08-25 for the native-vs-Smart-Cart flag test.

   INERT BY DEFAULT. Every behavior below is gated on the html.ci-native-cart
   class (stamped by the inline flag snippet in theme.liquid, or at runtime by
   window.CINativeCart.enable(), which Intelligems variant JS will call).
   Control shoppers: this file only defines window.CINativeCart and attaches
   listeners that early-return. It NEVER touches the product form or the buy
   button — add-to-cart flows through the theme's stock path (global.js ->
   miniCart.renderContents), which already opens the native drawer.

   Suppression is layered (any one alone is enough to keep Smart Cart closed):
   1. CSS: ci-native-cart.css hides #rebuy-cart under the flag class.
   2. rebuy:smartcart.show -> Rebuy.SmartCart.hide() + open native drawer.
   3. Rebuy.SmartCart.skip_open = true (public seam, best-effort). */
(function () {
  'use strict';

  var root = document.documentElement;

  /* 2026-09-22 MONEY IS NEVER ESTIMATED. Ondrej's screen recording, notes
     "decimals" and "flickering discount 30% in cart". The optimistic layer
     used to paint dollar figures before Shopify answered: unit x qty on a
     row, subtotal +/- a delta, the band's "Add $X more" minus a delta, and
     on every add a remembered sale ("Extra 30% OFF applied", learned into
     sessionStorage.ci_promo on 09-02 for the old 30%-off sale) with its
     percentage knocked off the price. That was right while every discount
     was a flat percentage. Under BUY 2, GET 1 FREE (cart-wide, cheapest
     unit of each three) plus codes that win or lose against it, the real
     price is not a function of one line, so every estimate was wrong.
     Measured frame by frame in the recording:
       qty 2->3  band  "Add $21.50"  then  "Add $41"   (bar moved BACKWARD)
       qty 3->4  total "$77.33 $50.67"  then  "$78 $58"
       qty 5->6  band  "Add $0 more", bar full, then "Add $2 more"
       every add "Extra 30% OFF applied" for ~1s, then the real line
     Now: rows, quantities and the pulse still update instantly; every money
     figure keeps its last TRUE value and dims (.ci-money-pending) until the
     server render replaces it, once. Set true to restore the old estimates,
     which is only safe if discounts go back to flat percentages. */
  window.__ciEstimateMoney = false;
  try { sessionStorage.removeItem('ci_promo'); } catch (e) {}

  var api = {
    get enabled() { return root.classList.contains('ci-native-cart'); },
    enable: function () {
      root.classList.add('ci-native-cart');
      applyRebuySeams();
      ensureWidget();
    },
    disable: function () {
      root.classList.remove('ci-native-cart');
    },
    /* 2026-08-28: public open for the PDP upsell's optimistic-add flow
       (fastest-stack variant); defined below, hoisted function. */
    open: function () { return openNativeDrawer(); }
  };
  window.CINativeCart = api;

  /* 2026-09-02 (Ondrej: "track all cart engagement metrics, capture every
     improvement"). ONE tracker for every cart / recommendation event. Sinks:
     GA4 through the store's own gtag (measurement id below, the same one
     Intelligems reports experience_impression to, so arms can be segmented),
     the dataLayer, and Microsoft Clarity. Params are ci_-prefixed, strings
     capped at 100 chars (GA4 limit). Register the ci_* params as event-scoped
     custom dimensions in GA4 admin to see them in reports. */
  var CI_GA4_ID = 'G-MX1XY86PWY';
  function track(evt, extra) {
    try {
      var payload = { ci_arm: 'native', ci_theme: String((window.Shopify && Shopify.theme && Shopify.theme.id) || '') };
      var k;
      if (extra) for (k in extra) {
        if (extra[k] === undefined || extra[k] === null) continue;
        payload[k] = typeof extra[k] === 'number' ? extra[k] : String(extra[k]).slice(0, 100);
      }
      try { window.dataLayer = window.dataLayer || []; var dl = { event: evt }; for (k in payload) dl[k] = payload[k]; window.dataLayer.push(dl); } catch (e1) {}
      try { if (typeof window.gtag === 'function') { var g = {}; for (k in payload) g[k] = payload[k]; g.send_to = CI_GA4_ID; window.gtag('event', evt, g); } } catch (e2) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', evt); } catch (e3) {}
      try { (window.__ciTrackLog = window.__ciTrackLog || []).push([Date.now(), evt, payload]); } catch (e4) {}
    } catch (e) {}
  }
  window.__ciTrack = track;
  /* drawer open / close timing (details toggle does not bubble; capture does) */
  document.addEventListener('toggle', function (e) {
    try {
      var det = e.target;
      if (!det || !det.classList || !det.classList.contains('cart-drawer-container')) return;
      if (det.hasAttribute('open')) { window.__ciCartOpenedAt = Date.now(); }
      else if (window.__ciCartOpenedAt) {
        track('ci_cart_close', { ci_secs_open: Math.round((Date.now() - window.__ciCartOpenedAt) / 1000) });
        window.__ciCartOpenedAt = 0;
      }
    } catch (err) {}
  }, true);

  /* ---------- native drawer open ---------- */
  /* ATC outcome guard (Ondrej approved 2026-08-31). Nothing is bound to the
     buy button itself — the hard rule stands. This only watches the RESULT:
     if a tap does not produce a visible drawer within ~400ms (the panel can
     land in a half-open state where details[open] is set but the closing
     class pins it hidden), close it cleanly and open it again. Never
     re-submits and never touches the add request, so it cannot double-add. */
  function drawerIsVisible() {
    try {
      var panel = document.querySelector('.cart-drawer');
      if (!panel) return false;
      var box = panel.getBoundingClientRect();
      return getComputedStyle(panel).visibility !== 'hidden' &&
             box.width > 0 && box.left < window.innerWidth - 20;
    } catch (e) { return false; }
  }

  function ensureDrawerVisible() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (drawerIsVisible() || attempts > 12) { clearInterval(timer); return; }
      if (attempts === 4 || attempts === 9) {
        var det = document.querySelector('details.cart-drawer-container');
        var mc = document.querySelector('mini-cart#mini-cart');
        try {
          if (det) {
            det.removeAttribute('open');
            det.classList.remove('menu-opening');
            det.classList.remove('menu-closing');
          }
          document.body.classList.remove('mini-cart--closing');
          document.body.classList.remove('mini-cart--opening');
        } catch (e) {}
        setTimeout(function () {
          if (mc && typeof mc.open === 'function') mc.open();
        }, 30);
      }
    }, 100);
  }

  window.__ciEnsureDrawerVisible = ensureDrawerVisible;

  function openNativeDrawer() {
    var mc = document.querySelector('mini-cart#mini-cart');
    if (mc && typeof mc.open === 'function') {
      mc.open();
      return true;
    }
    var det = document.querySelector('cart-drawer details');
    if (det && !det.hasAttribute('open')) det.setAttribute('open', '');
    return !!det;
  }

  /* ---------- Smart Cart suppression ---------- */
  function applyRebuySeams() {
    if (!api.enabled) return;
    try {
      if (window.Rebuy && Rebuy.SmartCart) Rebuy.SmartCart.skip_open = true;
    } catch (e) {}
  }

  document.addEventListener('rebuy:ready', applyRebuySeams);
  applyRebuySeams();

  /* Rebuy fires smartcart.show as a REFLEX to any /cart/change.js it
     observes (the PDP upsell widget suppresses exactly this in control).
     Translating every show into a native-drawer open made the cart pop open
     when removing an item from the PDP widget (Ondrej 2026-08-26). Only an
     ADD may open the drawer from this path; icon/dock clicks open it
     directly elsewhere. Smart Cart itself always stays hidden. */
  var lastRebuyAddAt = 0;
  document.addEventListener('rebuy:cart.add', function () { lastRebuyAddAt = Date.now(); });

  document.addEventListener('rebuy:smartcart.show', function () {
    if (!api.enabled) return;
    try {
      if (window.Rebuy && Rebuy.SmartCart) Rebuy.SmartCart.hide();
    } catch (e) {}
    if (Date.now() - lastRebuyAddAt < 3000) openNativeDrawer();
  });

  /* Mobile dock cart button: theme.liquid binds it to Rebuy.SmartCart.show().
     Capture-phase interception at the document root runs before any element
     handler; stopImmediatePropagation keeps the Rebuy binding from firing. */
  document.addEventListener('click', function (e) {
    if (!api.enabled) return;
    if (!e.target || !e.target.closest) return;
    var dock = e.target.closest('.dock__item[data-action="cart"]');
    if (dock) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openNativeDrawer();
    }
  }, true);

  /* ---------- Rebuy upsell widget inside the drawer ---------- */
  /* The mini-cart section HTML (with the #ci-cart-upsell slot) is replaced on
     first open (lazy fetch) and on every cart change (renderContents). After
     each replacement the slot div is unmounted, so we re-run Rebuy.init(),
     debounced, only when an unmounted slot is present. */
  /* Widget mounting is a bounded POLL, not event choreography (2026-08-26:
     Ondrej's drawer kept serving without the upsell after every event-based
     fix; one earlier retry even checked a DETACHED slot node from before a
     re-render). Every second: if an unmounted slot exists in the LIVE DOM
     and Rebuy is up, call Rebuy.init(). Runs for 30s after load and restarts
     its window on every drawer open / cart render, so no timing permutation
     escapes. Idle cost: one querySelector per tick, stops when mounted. */
  var mountPollUntil = 0;
  var mountPollTimer = null;
  var initAttempts = 0;
  var mountReported = false;

  function widgetMountTick() {
    if (!api.enabled) return;
    var slot = document.querySelector('#ci-cart-upsell [data-rebuy-id]');
    if (slot && slot.querySelector('[id^="rebuy-widget-"]')) {
      if (!mountReported) { mountReported = true; track('ci_upsell_mounted', { ci_init_attempts: initAttempts }); }
      return;
    }
    mountReported = false;
    if (slot && window.Rebuy && typeof Rebuy.init === 'function') {
      initAttempts++;
      try { Rebuy.init(); } catch (e) {}
      if (initAttempts === 8) track('ci_upsell_mount_stuck', { ci_rebuy_present: true });
    }
    if (Date.now() < mountPollUntil) {
      clearTimeout(mountPollTimer);
      mountPollTimer = setTimeout(widgetMountTick, 1000);
    }
  }

  function ensureWidget() {
    if (!api.enabled) return;
    mountPollUntil = Date.now() + 30000;
    widgetMountTick();
  }
  document.addEventListener('rebuy:ready', ensureWidget);
  if (document.readyState !== 'loading') ensureWidget();
  else document.addEventListener('DOMContentLoaded', ensureWidget);

  /* PREFETCH the drawer content shortly after load (variant only): the
     pending line can only paint into an already-rendered list, and on a
     fresh PDP the theme lazy-fetches the drawer on first open — which made
     instant-open show a spinner instead of the arm-B "item right away"
     (Ondrej 2026-08-26). Reuses the component's own fetch path. */
  /* 2026-08-31 (Ondrej, iPhone private window): on a COLD first tap the
     drawer's lazy fetch was still in flight, so the panel opened showing the
     PRE-ADD cart ("Your cart is empty!" + unstyled empty-state picks) and
     that render wiped the optimistic row. Any add in flight now suppresses
     stale content fetches; the add response renders the real cart. */
  window.__ciPendingAdd = window.__ciPendingAdd || 0;
  function addPending() { return Date.now() - (window.__ciPendingAdd || 0) < 8000; }

  /* A content fetch that was ALREADY in flight when the tap happened cannot
     be cancelled, so its (pre-add) HTML can still land on top of the
     optimistic paint — Ondrej's iPhone recording 2026-08-31 showed the empty
     cart replacing the pending row. Watch the drawer while an add is in
     flight and immediately re-suppress any empty state that appears. */
  (function () {
    var host = null;
    var repainting = false;
    function enforce() {
      if (!addPending() || repainting) return;
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;
      if (mc.classList.contains('is-empty')) mc.classList.remove('is-empty');
      if (!mc.classList.contains('ci-optimistic-pending')) mc.classList.add('ci-optimistic-pending');
      /* A stale (pre-add) render can replace the drawer body and take the
         pending row with it — Ondrej's 18:18 recording showed the empty cart
         appearing where the row had been. Put it back. */
      var html = window.__ciPendingRowHTML;
      if (!html || mc.querySelector('.ci-optimistic-row')) return;
      repainting = true;
      try {
        var ci = mc.querySelector('cart-items');
        var list = ci && ci.querySelector('.mini-cart__navigation');
        if (!list) {
          list = document.createElement('ul');
          list.className = 'mini-cart__navigation ci-optimistic-list';
          var hdr = mc.querySelector('.mini-cart__header');
          if (hdr) hdr.insertAdjacentElement('afterend', list);
          else mc.insertBefore(list, mc.firstChild);
        }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var node = holder.firstElementChild;
        if (node) {
          list.insertBefore(node, list.firstChild);
          revealRow(node);
        }
      } catch (e) {}
      repainting = false;
    }
    function watch() {
      host = document.getElementById('mini-cart');
      if (!host || host.__ciWatched) return;
      host.__ciWatched = true;
      try {
        new MutationObserver(enforce).observe(host, { childList: true, subtree: true });
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    document.addEventListener('ci:cart:rerendered', watch);
  })();

  function prefetchDrawer() {
    if (!api.enabled) return;
    if (addPending()) return;
    try {
      var mc = document.querySelector('mini-cart#mini-cart');
      if (!mc || typeof mc.handleIntersection !== 'function') return;
      if (mc.querySelector('.mini-cart__navigation')) return;  /* already loaded */
      mc.handleIntersection([{ isIntersecting: true }], { unobserve: function () {} });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') setTimeout(prefetchDrawer, 1200);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(prefetchDrawer, 1200); });

  /* 2026-10-13 (Ondrej, iPhone: "both gift and product no photo for a sec" on
     the first add from a PDP or the PDP upsell): the add response paints
     brand-new <img> tags whose files only start downloading then, so the line
     photo and the gift photo sat grey for ~1s. Start those downloads on the
     tap instead: the line photo at the drawer's own size, every gift photo the
     drawer can show, and (PDP adds) the picks pool of the added product, so
     "Others also bought" fills one round trip sooner. The add response takes
     ~0.8s, the small photos ~0.2s. */
  var warmed = {}, warmKeep = [];
  function warmImg(u) {
    if (!u || warmed[u]) return;
    warmed[u] = 1;
    var im = new Image();
    im.src = u;
    warmKeep.push(im);
  }
  window.__ciWarmAdd = function (photo, pid) {
    try {
      if (photo && /[?&]width=\d+/.test(photo)) {
        var dpr = Math.min(3, Math.max(1, Math.round(window.devicePixelRatio || 1)));
        warmImg(photo.replace(/([?&]width=)\d+/, '$1' + (90 * dpr)));
      }
      var gw = document.querySelector('#mini-cart [data-ci-gift-warm]');
      if (gw) gw.getAttribute('data-ci-gift-warm').split(/\s+/).forEach(warmImg);
      var gs = document.querySelector('#mini-cart script[data-ci-gift-state]');
      if (gs) (JSON.parse(gs.textContent).g || []).forEach(function (g) { warmImg(g.i); warmImg(g.m); });
      pid = pid ? String(pid) : '';
      var pc = window.__ciRecsPool;
      if (!pid || (pc && pc.key === pid) || warmed['pool:' + pid]) return;
      warmed['pool:' + pid] = 1;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=complementary', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json) return;
          var items = (json.products || []).filter(function (p) { return p && p.handle && p.available !== false; });
          var cur = window.__ciRecsPool;
          if (!(cur && cur.key === pid)) window.__ciRecsPool = { key: pid, items: items, intent: items.length ? 'complementary' : 'related' };
        })
        .catch(function () {});
    } catch (e) {}
  };
  /* Same fix, fallback: when the real render lands before the line photo has
     downloaded, the new <img> shows the optimistic row's photo (same file,
     already on screen) as its background until its own pixels arrive. */
  function underlayLinePhoto(optSrc) {
    try {
      var base = function (u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); };
      var want = base(optSrc);
      document.querySelectorAll('#mini-cart cart-items li img').forEach(function (im) {
        if ((im.complete && im.naturalWidth) || base(im.getAttribute('src')) !== want) return;
        im.style.background = 'url("' + optSrc + '") center / cover no-repeat';
      });
    } catch (e) {}
  }

  /* The theme's cart custom elements re-render sections without emitting any
     event; patch renderContents (drawer-scoped code, NOT the product form) to
     announce it. Guarded so a double-include can't double-patch. */
  function patchRender(tag) {
    var C = customElements.get(tag);
    if (!C || !C.prototype || C.prototype.__ciCartPatched) return;
    var orig = C.prototype.renderContents;
    if (typeof orig !== 'function') return;
    C.prototype.renderContents = function (parsedState) {
      /* renderContents auto-opens the drawer for EVERY render. Control never
         shows that (Smart Cart hides the native drawer), so in the variant it
         surfaced as "cart opens when I remove an item from the PDP widget"
         (Ondrej 2026-08-26). Adds must open; changes/removes must not.
         /cart/add.js responses have no `token`; /cart/change|update.js
         return the FULL cart (token present) — suppress open for those. */
      var optImg = tag === 'mini-cart' && document.querySelector('#mini-cart .ci-optimistic-row img');
      var optSrc = optImg ? (optImg.currentSrc || optImg.src) : '';
      var suppressOpen = api.enabled && parsedState && parsedState.token !== undefined;
      var realOpen = this.open;
      if (suppressOpen && typeof realOpen === 'function') this.open = function () {};
      var r;
      try {
        r = orig.apply(this, arguments);
      } finally {
        if (suppressOpen && typeof realOpen === 'function') this.open = realOpen;
      }
      if (optSrc) underlayLinePhoto(optSrc);
      try {
        document.dispatchEvent(new CustomEvent('ci:cart:rerendered'));
      } catch (e) {}
      return r;
    };
    C.prototype.__ciCartPatched = true;
  }
  ['mini-cart', 'cart-items'].forEach(function (t) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined(t).then(function () { patchRender(t); }).catch(function () {});
    }
  });

  /* Guard the drawer's lazy-load (2026-08-28): prefetchDrawer calls
     handleIntersection with a FAKE observer, so the element's REAL
     IntersectionObserver stays armed and fires on first open — refetching
     the PRE-add cart over the optimistic paint (Ondrej's show/disappear/
     show flick on first add). Skip the fetch whenever drawer content
     already exists. */
  function patchLazyLoad() {
    var C = customElements.get('mini-cart');
    if (!C || !C.prototype || C.prototype.__ciLazyPatched) return;
    var orig = C.prototype.handleIntersection;
    if (typeof orig !== 'function') return;
    C.prototype.handleIntersection = function (entries, observer) {
      if (entries && entries[0] && !entries[0].isIntersecting) return;
      if (addPending()) {           /* stale pre-add cart would flash */
        try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
        return;
      }
      if (this.querySelector('.mini-cart__navigation') ||
          this.querySelector('.ci-optimistic-shell') ||
          this.querySelector('.mini-cart')) {
        try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
        return;
      }
      /* 2026-09-02: the original fetch cannot be cancelled, so a tap that
         lands while the prefetch is in flight got the PRE-add cart painted
         over its optimistic row/bump ~1s later (merge path: qty 3 -> 2 -> 3).
         Same fetch, but the response is dropped when an add is pending or a
         real render has landed meanwhile; the add's own render (or the
         reconcile refresh) supplies the content instead. */
      try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
      var self = this;
      var startedAt = Date.now();
      fetch(this.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (addPending()) return;
          if (window.__ciLastRenderAt && window.__ciLastRenderAt > startedAt) return;
          if (self.querySelector('.mini-cart__navigation') || self.querySelector('.mini-cart')) return;
          var host = document.getElementById('mini-cart');
          if (!host) return;
          host.innerHTML = self.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
        })
        .catch(function () {});
    };
    C.prototype.__ciLazyPatched = true;
  }
  /* 2026-09-02: patching after whenDefined() is too late for the element's
     OWN IntersectionObserver: connectedCallback runs during define() and
     binds the ORIGINAL handleIntersection, so the first time the drawer
     became visible that bound original fetched the pre-add cart and stomped
     the optimistic totals (subtotal 366.10 -> 0.00 -> 366.10, measured on
     both mobile and desktop). This script is a deferred head script and
     cart-drawer.js is a deferred body script, so it runs first: wrap
     customElements.define and patch the prototype BEFORE registration. The
     whenDefined path stays as the fallback for any other load order. */
  try {
    if (window.customElements && !customElements.__ciDefineWrapped) {
      var origDefine = customElements.define.bind(customElements);
      customElements.define = function (name, ctor, opts) {
        if (name === 'mini-cart' && ctor && ctor.prototype && !ctor.prototype.__ciLazyPatched) {
          var orig = ctor.prototype.handleIntersection;
          if (typeof orig === 'function') {
            ctor.prototype.handleIntersection = function (entries, observer) {
              if (entries && entries[0] && !entries[0].isIntersecting) return;
              try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
              if (addPending()) return;
              if (this.querySelector('.mini-cart__navigation') ||
                  this.querySelector('.ci-optimistic-shell') ||
                  this.querySelector('.mini-cart')) return;
              var self = this;
              var startedAt = Date.now();
              fetch(this.dataset.url)
                .then(function (r) { return r.text(); })
                .then(function (html) {
                  if (addPending()) return;
                  if (window.__ciLastRenderAt && window.__ciLastRenderAt > startedAt) return;
                  if (self.querySelector('.mini-cart__navigation') || self.querySelector('.mini-cart')) return;
                  var host = document.getElementById('mini-cart');
                  if (!host) return;
                  host.innerHTML = self.getSectionInnerHTML(html, '.shopify-section');
                  document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
                })
                .catch(function () {});
            };
            ctor.prototype.__ciLazyPatched = true;
          }
        }
        return origDefine(name, ctor, opts);
      };
      customElements.__ciDefineWrapped = true;
    }
  } catch (e) {}
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('mini-cart').then(patchLazyLoad).catch(function () {});
  }

  /* ---------- Smart Cart parity retexts (2026-08-26) ---------- */
  /* The native drawer must read like the control Smart Cart so the test
     isolates the engine, not the copy. All writes are value-guarded so
     re-running on every render is a no-op. Reference strings measured off
     the live control cart 2026-08-26. */
  function applyParityText() {
    if (!api.enabled) return;
    try {
      var title = document.querySelector('.mini-cart__header .title');
      if (title && !/^Your cart/i.test(title.textContent.trim())) title.textContent = 'Your cart'; /* V4 2026-09-18: Liquid renders "Your cart (N)"; only a foreign title gets replaced */

      /* "Spend X more to reach free shipping" -> "You are X away from FREE
         SHIPPING!", keeping the theme's own <price-money> node for the
         amount so currency formatting stays correct. Success state keeps
         the native congratulations line. */
      /* 2026-09-22 unlock moment (Spark run): the celebration marks CROSSING
         $79, not every render. The drawer rebuilds this node on any qty
         change, so a bare CSS animation would replay the spark each time a
         shopper edits an already-qualifying cart. Stamp the class only on a
         locked -> unlocked transition; a cart that is ALREADY unlocked the
         first time we see it is recorded silently, never celebrated. State
         hangs off window because this file is several IIFEs. */
      var ciBand = document.querySelector('.mini-cart .free-shipping');
      var ciOk = document.querySelector('.mini-cart .free-shipping.ci-fs--ok');
      if (ciOk) {
        if (window.__ciFsUnlocked === false) ciOk.classList.add('ci-fs--celebrate');
        window.__ciFsUnlocked = true;
      } else if (ciBand) {
        window.__ciFsUnlocked = false;
      }

      var fs = document.querySelector('.mini-cart .free-shipping__text:not(.free-shipping__text--success)');
      if (fs && !fs.hasAttribute('data-ci-retexted')) {
        var money = fs.querySelector('price-money');
        if (money) {
          var amountHTML = money.outerHTML;
          /* Parity 2026-08-28: control's Smart Cart countdown phrasing. */
          fs.innerHTML = 'You are ' + amountHTML + ' away from <b>FREE SHIPPING</b>!';
        }
        fs.setAttribute('data-ci-retexted', '1');
      }
      /* Success state: control says "🎉 Congrats! You've unlocked FREE
         SHIPPING!" (captured off the live control 2026-08-27). */
      var fsOk = document.querySelector('.mini-cart .free-shipping__text--success');
      if (fsOk && !fsOk.hasAttribute('data-ci-retexted')) {
        fsOk.innerHTML = '🎉 Congrats! You’ve unlocked <b>FREE SHIPPING!</b>';
        fsOk.setAttribute('data-ci-retexted', '1');
      }

      /* "Subtotal" -> "Subtotal (N items)" with N from the drawer's qty
         inputs (the same numbers the section just rendered). */
      var label = document.querySelector('.mini-cart .subtotal .label');
      if (label) {
        var n = 0;
        document.querySelectorAll('.mini-cart__navigation .quantity__input').forEach(function (i) {
          n += parseInt(i.value, 10) || 0;
        });
        var want = 'Subtotal (' + n + (n === 1 ? ' item' : ' items') + ')';
        /* V4 2026-09-18: the header already carries the count ("Your cart (N)"),
           so the subtotal label stays plain and the line fits with the pill */
        if (document.querySelector('.mini-cart.ci-cart-v4')) want = 'Subtotal';
        if (n > 0 && label.textContent.trim() !== want) label.textContent = want;
      }

      /* CTA carries no total (2026-08-31 parity): nothing to retext. */

      /* The shop money format prints "$ 56" (space after a LEADING symbol);
         control renders "$56". Trailing symbols (THB ฿) get exactly one
         space, matching control's "399.00 ฿". */
      document.querySelectorAll('.mini-cart price-money bdi').forEach(function (b) {
        var h = b.innerHTML;
        var fixed = h.replace(/^(\s*<span class="price__prefix">[^<]*<\/span>)\s+/, '$1');
        fixed = fixed.replace(/\s*(<span class="price__prefix">[^<]*<\/span>)\s*$/, '$1');
        if (fixed !== h) b.innerHTML = fixed;
      });

      /* Learn the automatic discount from rendered lines so the next optimistic
         row can paint the same SALE line and discounted price on first paint.
         Off while window.__ciEstimateMoney is false (see the top of file). */
      if (window.__ciEstimateMoney === true) try {
        var learned = null;
        try { learned = JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || {}; } catch (le) { learned = {}; }
        learned.handles = learned.handles || {};
        var changed = false;
        document.querySelectorAll('.mini-cart cart-items li[data-handle]').forEach(function (li) {
          var d = li.querySelector('.discounts__discount');
          var t = d ? d.textContent.replace(/\s+/g, ' ').trim() : '';
          var pmm = t.match(/(\d{1,2})\s*%\s*off/i);
          if (!pmm) return;
          if (learned.title !== t || learned.pct !== parseInt(pmm[1], 10)) { learned.title = t; learned.pct = parseInt(pmm[1], 10); changed = true; }
          var h = li.getAttribute('data-handle');
          if (h && !learned.handles[h]) { learned.handles[h] = 1; changed = true; }
        });
        if (changed) sessionStorage.setItem('ci_promo', JSON.stringify(learned));
      } catch (e5) {}

      /* Empty state: mirror the control Smart Cart's empty_cart_markup
         (copied from the Rebuy config 2026-08-26 — re-sync if it changes). */
      var emptyBox = document.querySelector('.mini-cart.is-empty .mini-cart__empty');
      if (emptyBox && !emptyBox.hasAttribute('data-ci-parity')) {
        emptyBox.innerHTML =
          '<h4 class="ci-empty-title">Your cart is empty!</h4>' +
          '<p class="ci-empty-text">Add your favorite items to your cart.</p>' +
          '<p class="ci-empty-link"><a href="/collections/all">Shop Now</a></p>';
        emptyBox.setAttribute('data-ci-parity', '1');
      }
    } catch (e) {}
  }

  function onCartRendered() {
    ensureWidget();
    applyParityText();
    /* 2026-09-02: the upsell widget announces the render before its section
       swap has fully settled, so the "(N items)" count was missing on that
       path; one deferred pass is value-guarded and cheap. */
    setTimeout(applyParityText, 80);
    setTimeout(applyParityText, 500);
    setTimeout(applyParityText, 1500);
  }

  /* 2026-09-02: the theme's own cart.js re-renders the free-shipping bar and
     line list on qty changes without firing our events, which put the stock
     "You are eligible for free shipping." back (Ondrej's screenshot). Watch
     the drawer subtree and re-apply the value-guarded parity pass. */
  (function () {
    var host = document.getElementById('mini-cart');
    if (!host || typeof MutationObserver !== 'function') return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(applyParityText, 40);
    }).observe(host, { childList: true, subtree: true });
  })();
  document.addEventListener('cartdrawer:opened', onCartRendered);     /* first lazy fetch */
  document.addEventListener('ci:cart:rerendered', onCartRendered);    /* ATC / qty updates */
  document.addEventListener('rebuy:cart.change', ensureWidget);       /* rebuy-side changes */

  /* ---------- drawer refresh on Rebuy-originated cart changes ---------- */
  /* Adds from the upsell widget run through Rebuy's pipeline and bypass the
     theme's renderContents, leaving the drawer stale (found in QA 2026-08-25:
     cart.js said 2 items, drawer showed 1). Refresh the cart sections via the
     Section Rendering API. Theme-side renders mark lastThemeRender so a
     native qty/remove/ATC (which Rebuy's fetch-watcher also reports as
     rebuy:cart.change) does not trigger a redundant second fetch. */
  var refreshTimer = null;
  var lastThemeRender = 0;

  /* Only THEME-sourced renders (renderContents patch) count as "already
     fresh"; our own refresh dispatches with detail.source='refresh' so a
     rapid second widget add still gets its refresh. Our ?sections= GET is not
     a cart mutation, so Rebuy's fetch-watcher never reports it and there is
     no self-loop. */
  document.addEventListener('ci:cart:rerendered', function (e) {
    if (e.detail && e.detail.source === 'refresh') return;
    lastThemeRender = Date.now();
    clearTimeout(refreshTimer);
  });

  var lastRefreshStart = 0;

  function scheduleRefresh(delayMs) {
    if (!api.enabled) return;
    if (Date.now() - lastThemeRender < 1200) return;   /* theme just rendered */
    if (Date.now() - lastRefreshStart < 1200) return;  /* refresh already running */
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(doRefresh, typeof delayMs === 'number' ? delayMs : 600);
  }

  function doRefresh(isRetry) {
    lastRefreshStart = Date.now();
    var ids = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootPath + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ids.forEach(function (id) {
          var target = document.getElementById(id);
          var html = sections[id];
          if (!target || !html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (inner) target.innerHTML = inner.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('ci:cart:rerendered', { detail: { source: 'refresh' } }));
      })
      .catch(function () {
        /* 2026-09-02: a refresh that fails (rate limit, blip) would leave the
           optimistic numbers on screen with nothing to reconcile them; one
           retry covers the transient case. */
        if (!isRetry) setTimeout(function () { doRefresh(true); }, 2500);
      });
  }
  window.__ciDrawerRefresh = doRefresh;

  /* 2026-09-02 reliability pass (Ondrej): the optimistic layer paints on top
     of whatever the drawer currently shows, so a STALE drawer (back from
     checkout via bfcache, cart edited in another tab, a failed request) makes
     the optimistic math visibly wrong until the next real render. Re-pull
     the drawer sections when the page is restored from bfcache, and when the
     tab becomes visible again after more than a minute without a render. */
  window.__ciLastRenderAt = Date.now();
  document.addEventListener('ci:cart:rerendered', function () { window.__ciLastRenderAt = Date.now(); });
  document.addEventListener('cartdrawer:opened', function () { window.__ciLastRenderAt = Date.now(); });
  window.addEventListener('pageshow', function (e) {
    try { if (e.persisted && api.enabled && !addPending()) doRefresh(); } catch (err) {}
  });
  document.addEventListener('visibilitychange', function () {
    try {
      if (document.visibilityState === 'visible' && api.enabled && !addPending() &&
          Date.now() - window.__ciLastRenderAt > 60000) doRefresh();
    } catch (err) {}
  });

  /* rebuy:cart.add fires at the add response (~900ms before cart.change):
     refresh immediately so a widget add lands in the drawer in one fetch
     round-trip. cart.change stays as the debounced catch-all. */
  document.addEventListener('rebuy:cart.add', function () { scheduleRefresh(0); });
  document.addEventListener('rebuy:cart.change', function () { scheduleRefresh(600); });

  /* ---------- instrumentation ---------- */
  /* Drawer open: <details> fires a non-bubbling toggle; listen in capture. */
  document.addEventListener('toggle', function (e) {
    if (!api.enabled) return;
    var det = e.target;
    if (det && det.classList && det.classList.contains('cart-drawer-container') && det.hasAttribute('open')) {
      track('ci_cart_open', { ci_items: document.querySelectorAll('.mini-cart cart-items li').length });
      ensureWidget();
    }
  }, true);

  /* Upsell ATC: any click on the widget's own ADD button inside our slot.
     Rebuy's button does the actual add (preserving its attribution); we paint
     an OPTIMISTIC pending line immediately (add.js TTFB is ~1-1.5s on this
     store and the sections refresh another ~1.5s — without this the add feels
     dead for ~3s). The pending line is display-only (pointer-events:none) and
     the next full render replaces the list wholesale, so reconciliation is
     automatic; a 10s timer sweeps it if the refresh never lands. */
  function paintPendingLine(imgSrc, titleText, priceText, compareText, extra) {
    try {
      if (window.__ciWarmAdd) window.__ciWarmAdd(imgSrc);
      var list = document.querySelector('.mini-cart__navigation');
      if (!list || !titleText) return;
      /* 2026-09-02 (Ondrej: SALE line missing during the flicker on widget adds):
         same rules as the PDP form path. Sale eligibility rides on the card
         (data-ci-sale), the discount title/pct is the one learned from rendered
         lines; discounted price only next to a compare-at (theme rule). */
      extra = extra || {};
      var promoLine = '', optionLine = '';
      try {
        var rc = window.__ciEstimateMoney === true ? (JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null) : null;
        if (extra.sale && rc && rc.title) {
          promoLine = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + String(rc.title).replace(/</g, '&lt;') + '</li></ul>';
          var pct = parseInt(rc.pct, 10) || 0;
          var m0 = compareText && priceText ? priceText.match(/[0-9][0-9.,]*/) : null;
          if (pct > 0 && pct < 100 && m0) {
            var base = parseFloat(m0[0].replace(/,/g, '')) || 0;
            if (base) {
              var parts = (base * (1 - pct / 100)).toFixed(2).split('.');
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              priceText = priceText.replace(m0[0], parts.join('.'));
            }
          }
        }
        if (extra.option) optionLine = '<dl><div class="product-option"><dd>' + String(extra.option).replace(/</g, '&lt;') + '</dd></div></dl>';
      } catch (pe) {}
      /* money waits for the server render (top of file) */
      if (window.__ciEstimateMoney !== true) { priceText = ''; compareText = ''; }
      var dup = Array.prototype.some.call(
        list.querySelectorAll('.ci-optimistic-line .product-title'),
        function (t) { return t.textContent.trim() === titleText; }
      );
      if (dup) return;
      var li = document.createElement('li');
      /* 2026-08-31 (Ondrej): this line used a hardcoded 70px thumb while real
         rows render 90px, so an upsell add flickered in at the wrong size.
         Use the same classes/structure as a real line item and let the
         reskin size it; pulse like every other optimistic paint. */
      li.className = 'ci-optimistic-line ci-optimistic-row ci-opt-pulse';
      li.style.cssText = 'pointer-events:none;';
      li.innerHTML =
        '<div class="product-container">' +
          (imgSrc ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + imgSrc + '" alt="" style="width:100%;display:block;"></span></div>' : '') +
          '<div class="product-description"><div class="product-content">' +
            '<span class="link product-title">' + titleText + '</span>' +
          '</div>' + optionLine + promoLine +
          '<div class="product-quantity">' +
            '<dt><quantity-input class="quantity">' +
              '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
              '<input class="quantity__input" type="text" value="1" readonly aria-label="Quantity">' +
              '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
            '</quantity-input></dt>' +
            /* 2026-09-02: identical price markup to the rendered line (dl/dd/s/igPrice), so nothing moves on confirm */
            ((compareText) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice"><price-money><bdi>' + (compareText) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice"><price-money><bdi>' + ((priceText || '')) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice"><price-money><bdi>' + ((priceText || '')) + '</bdi></price-money></dd>') +
          '</div></div>' +
          '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
        '</div>';
      list.insertBefore(li, list.firstChild);
      setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 10000);
      var empty = document.querySelector('.mini-cart.is-empty');
      if (empty) empty.classList.remove('is-empty');
    } catch (e) {}
  }

  function paintOptimisticLine(btn) {
    try {
      var card = btn.closest('.rebuy-product-block');
      if (!card) return;
      var img = card.querySelector('.rebuy-product-media img');
      var title = card.querySelector('.rebuy-product-title');
      var price = card.querySelector('.rebuy-money.sale') || card.querySelector('.rebuy-money');
      paintPendingLine(img && img.src, title && title.textContent.trim(), price && price.textContent.trim());
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!api.enabled) return;
    var btn = e.target.closest('#ci-cart-upsell .rebuy-button');
    if (btn) {
      track('ci_upsell_atc');
      paintOptimisticLine(btn);
    }
  }, true);

  /* Arm-B behavior for the PDP "Complete the ritual" widget (Ondrej
     2026-08-26): checking a card opens the cart IMMEDIATELY with a pending
     line, not after the add round-trip. Checkbox state at event time is the
     post-toggle state, so checked === add; removes never open. The label
     click re-dispatches onto the input, so the handler is idempotent
     (open() no-ops when open, paintPendingLine dedups by title). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!api.enabled) return;
    var box = e.target.closest('.product-upsell__checkbox');
    if (!box && e.target.closest('label')) {
      var lbl = e.target.closest('label');
      var forEl = lbl.htmlFor ? document.getElementById(lbl.htmlFor) : lbl.querySelector('.product-upsell__checkbox');
      if (forEl && forEl.classList && forEl.classList.contains('product-upsell__checkbox')) box = forEl;
    }
    if (!box) return;
    setTimeout(function () {
      if (!box.checked) return;
      openNativeDrawer();
      track('ci_pdp_upsell_open');
      try {
        /* card anatomy: input sits INSIDE label.product-upsell__card (a
           [class*=product-upsell] closest() matches the input itself). */
        var card = box.closest('.product-upsell__card') || box.parentElement;
        var img = card && card.querySelector('img');
        var titleEl = card && card.querySelector('.product-upsell__title');
        /* 2026-08-31 (Ondrej, THB screenshot): the old "last whitespace
           token" trick returned just the currency symbol for trailing-symbol
           currencies ("404.00 ฿" -> "฿"), so the pending row showed a lone
           red ฿. Read the price ELEMENT instead. */
        var priceEl = card && (
          card.querySelector('.product-upsell__price--sale') ||
          card.querySelector('[data-upsell-price]') ||
          card.querySelector('.product-upsell__price')
        );
        var priceText = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!priceText && card) {
          var grp = card.querySelector('.product-upsell__price-group');
          var m = grp && grp.textContent.replace(/\s+/g, ' ').match(/[^\s]*\d[\d.,]*\s?[^\s\d]*/g);
          if (m && m.length) priceText = m[m.length - 1].trim();
        }
        /* The title node contains a nested "More info" toggle whose text
           leaked into the pending line (Ondrej 2026-08-31). Clone, drop
           interactive children, then read the text. */
        var titleText = '';
        if (titleEl) {
          /* 2026-08-31 v2: stripping every <a> emptied the title (the title
             ITSELF is a link) and the pending line silently stopped
             painting. Drop only the "More info" affordance, then fall back
             to the raw text with that label trimmed. */
          var clean = function (t) {
            return String(t || '').replace(/\s+/g, ' ').replace(/\s*More info\s*$/i, '').trim();
          };
          var clone = titleEl.cloneNode(true);
          clone.querySelectorAll('[class*="more-info"], [class*="moreInfo"], .visually-hidden').forEach(function (n) { n.remove(); });
          titleText = clean(clone.textContent) || clean(titleEl.textContent);
        }
        /* Ondrej 2026-08-31: "show the price the same way as the main ATC" —
           that row renders red sale + struck compare-at, so the upsell row
           must carry the compare price too. */
        var compareEl = card && card.querySelector('.product-upsell__price--compare');
        var compareText = compareEl ? compareEl.textContent.replace(/\s+/g, ' ').trim() : '';
        paintPendingLine(
          img && (img.currentSrc || img.src),
          titleText,
          priceText,
          compareText,
          { sale: box.getAttribute('data-ci-sale') === '1', option: box.getAttribute('data-variant-title') || '' }
        );
      } catch (err) {}
    }, 0);
  }, true);

  /* ---------- boot ---------- */
  if (api.enabled) {
    track('ci_cart_exposure');
    applyRebuySeams();
  }
})();


/* ---------- OPTIMISTIC ATC v2 (2026-08-28, Ondrej) ----------
   Open the drawer and paint the added item the moment the buy button is
   pressed. v2: the painted row is a structural CLONE of a real line item
   (same classes -> same reskin styling: 90px image, underlined title,
   variant line, stepper, trash, red price + struck compare read off the
   PDP), so the real render replaces it without any visible morph. Also
   covers the empty-cart path (is-empty removed, row anchored after the
   header when no list exists yet). The theme's real submit flow is never
   touched; a failure here can never break the add. */
(function () {
  /* tracker lives in the first IIFE; alias it here so a call can never throw inside the optimistic paint */
  var track = function () { try { if (window.__ciTrack) window.__ciTrack.apply(null, arguments); } catch (e) {} };
  var WATCHDOG_MS = 9000;
  var pendingTimer = null;
  function cleanup() {
    if (window.__ciPendingAdd && !window.__ciReconciling) track('ci_cart_add_confirmed', { ci_ms: Date.now() - window.__ciPendingAdd });
    window.__ciPendingAdd = 0;
    window.__ciPendingRowHTML = null;
    document.querySelectorAll('.ci-optimistic-row, .ci-optimistic-list').forEach(function (n) { n.remove(); });
    document.querySelectorAll('.ci-opt-pulse, .ci-opt-removing, .ci-opt-qtying').forEach(function (n) {
      n.classList.remove('ci-opt-pulse');
      n.classList.remove('ci-opt-removing');
      n.classList.remove('ci-opt-qtying');
    });
    var m = document.querySelector('.mini-cart.ci-optimistic-pending');
    if (m) m.classList.remove('ci-optimistic-pending');
  }
  document.addEventListener('ci:cart:rerendered', function () { clearTimeout(pendingTimer); cleanup(); });

  /* ---- 2026-09-02 reliability pass: never leave a lie on screen ----
     Before this, a failed add (network drop, a 429 from Shopify, a sold-out
     422) left the painted row pulsing for 12s and then silently removed it,
     with the subtotal / item count still carrying the optimistic delta. Now
     every failure signal (theme pubsub cart-error, the recs element's
     ajaxProduct:error, or simply no render inside 9s) clears the optimistic
     layer, re-pulls the real drawer, and says so in one line. */
  function showNote(msg) {
    try {
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;
      var old = mc.querySelector('.ci-cart-note');
      if (old) old.remove();
      var n = document.createElement('div');
      n.className = 'ci-cart-note';
      n.setAttribute('role', 'status');
      n.textContent = msg;
      var hdr = mc.querySelector('.mini-cart__header');
      if (hdr && hdr.parentNode) hdr.insertAdjacentElement('afterend', n);
      else mc.insertBefore(n, mc.firstChild);
      setTimeout(function () { if (n.parentNode) n.remove(); }, 5000);
    } catch (e) {}
  }
  function reconcile(msg) {
    clearTimeout(pendingTimer);
    window.__ciReconciling = true;
    cleanup();
    window.__ciReconciling = false;
    track('ci_cart_error', { ci_msg: msg || '', ci_pending: window.__ciPendingAdd ? 1 : 0 });
    try { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); } catch (e) {}
    if (msg) showNote(msg);
  }
  window.__ciReconcile = reconcile;
  function armWatchdog() {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      if (window.__ciPendingAdd) reconcile("Your cart didn't update. Please try again.");
    }, WATCHDOG_MS);
  }
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, function (d) {
        var m = d && (d.message || (typeof d.errors === 'string' ? d.errors : ''));
        reconcile(m || "That item couldn't be added.");
      });
    }
  } catch (e) {}
  document.addEventListener('ajaxProduct:error', function (e) {
    var m = e && e.detail && e.detail.errorMessage;
    reconcile(m || "That item couldn't be added.");
  });
  (function watchSubmitButtons() {
    if (typeof MutationObserver === 'undefined') return;
    function check(btn) {
      if (!window.__ciPendingAdd) return;
      if (btn.classList.contains('loading')) return;
      setTimeout(function () {
        if (!window.__ciPendingAdd) return;
        if (Date.now() - (window.__ciLastRenderAt || 0) < 700) return;   /* a render landed: success */
        if (btn.classList.contains('loading')) return;
        reconcile("Your cart didn't update. Please try again.");
      }, 250);
    }
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.classList && t.classList.contains('product-form__submit')) check(t);
        }
      }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  })();

  /* Ondrej 2026-08-31: "the flicker often does not happen" — when the product
     is ALREADY in the cart we bump that row instead of painting a new one,
     and in a long cart that row can sit below the fold, so the feedback was
     invisible. Bring whatever we touched into view. */
  function revealRow(el) {
    if (!el) return;
    setTimeout(function () {
      try {
        var scroller = el.closest('.mini-cart__main') ||
                       el.closest('[style*="overflow"]') ||
                       document.querySelector('.mini-cart__main');
        if (scroller && scroller.scrollHeight > scroller.clientHeight) scroller.scrollTop = 0;
        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      } catch (e) {}
    }, 60);
  }

  function ciOptimisticAdd(form) {
    try {
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      /* 2026-09-02: the click listener AND the submit listener both reach here
         for one tap (by design, see below), and the MERGE path had no guard,
         so an existing line was bumped twice (qty 2 -> 4 for a single add,
         corrected ~1s later by the render). One paint per form per tap; and
         nothing while the theme still has the button in its loading state. */
      var now = Date.now();
      if (window.__ciLastOptForm === form && now - (window.__ciLastOptAt || 0) < 1500) return;
      if (form.querySelector('[type="submit"].loading')) return;
      window.__ciLastOptForm = form;
      window.__ciLastOptAt = now;
      window.__ciPendingAdd = now;
      var api = window.CINativeCart;
      if (api && api.open) api.open();
      /* defined in the cart-api IIFE above; call through window so a scope
         miss can never abort the optimistic paint (it did on 2026-08-31). */
      if (typeof window.__ciEnsureDrawerVisible === 'function') window.__ciEnsureDrawerVisible();
      var mc = document.querySelector('.mini-cart');
      if (mc && mc.querySelector('.ci-optimistic-row')) return;
      if (!mc) {
        /* Pre-prefetch state: the mini-cart container is still EMPTY (its
           content lazy-loads ~1.2s after page load), so a fast tap opened a
           bare shell with nothing to paint into — Ondrej's "item pops in
           later". Build a minimal drawer (header + list) with the real
           classes; the add-response render replaces it wholesale. */
        var host = document.getElementById('mini-cart');
        if (!host) return;
        host.innerHTML =
          '<div class="mini-cart ci-optimistic-shell">' +
            '<div class="mini-cart__header"><div class="title h4">Your cart</div></div>' +
          '</div>';
        mc = host.querySelector('.mini-cart');
      }

      var vid = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
      var qty = parseInt(((form.querySelector('[name="quantity"]') || {}).value) || '1', 10) || 1;
      var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
      track('ci_cart_add', {
        ci_source: form.closest('product-upsell') ? 'pdp_upsell' : (form.closest('.mini-cart') ? 'drawer' : (form.closest('.card, .card-wrapper, .product-card') ? 'card' : 'pdp_form')),
        ci_product: String((meta.product && meta.product.id) || ''), ci_variant: String(vid || ''), ci_qty: qty
      });
      var variants = (meta.product && meta.product.variants) || [];
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === vid) v = variants[i]; }
      var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1, h1');
      var title = titleEl ? titleEl.textContent.trim() : (v && v.name ? v.name : '');
      /* og:image can be absent or point at a share image; prefer the actual
         gallery image the shopper is looking at (Ondrej 2026-08-31: first add
         painted a row with no thumbnail). */
      var galleryImg = document.querySelector('.product__media img:not(.ci-blur-up), .product__media-item img:not(.ci-blur-up), .product__info-container img');
      var ogImg = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
      var img = (galleryImg && (galleryImg.currentSrc || galleryImg.src)) || (ogImg ? ogImg.content : '');
      if (window.__ciWarmAdd) window.__ciWarmAdd(img, meta.product && meta.product.id);
      var variantTitle = v && v.public_title && v.public_title !== 'Default Title' ? v.public_title : '';
      /* price shown = what the PDP shows right now (sale-aware); struck
         compare from the PDP's own struck element when present */
      var pdpPrice = document.querySelector('.product__info-container .igPrice, .product__info-container .price-item--sale, .product__info-container .price__sale .price-item');
      var pdpCompare = document.querySelector('.product__info-container .igComparePrice, .product__info-container s.price-item--regular, .product__info-container .price s');
      var priceTxt = pdpPrice ? pdpPrice.textContent.trim() : '';
      if (!priceTxt && v && v.price) { priceTxt = '$' + (v.price / 100).toFixed(2).replace(/\.00$/, ''); }
      var compareTxt = pdpCompare ? pdpCompare.textContent.trim() : '';
      /* 2026-09-21 (Ondrej: cart shows LINE totals, not unit prices): the PDP
         always shows a per-unit price regardless of the qty selector, so
         scale priceTxt/compareTxt by qty in place (preserving the currency
         symbol's position) BEFORE the promo % calc below, so a discounted
         row paints as a correctly-scaled line total too and does not visibly
         re-price when the real render lands. Local to this IIFE on purpose —
         fmtNum/parseMoney live in the separate OPTIMISTIC QTY/REMOVE IIFE
         further down and are not reachable from here. */
      var ciScaleByQty = function (txt) {
        if (!txt || qty === 1) return txt;
        var mm = txt.match(/[0-9][0-9.,]*/);
        if (!mm) return txt;
        var val = (parseFloat(mm[0].replace(/,/g, '')) || 0) * qty;
        var hadDec = /\d[.]\d{2}/.test(mm[0]);
        var s = val.toFixed(2);
        if (!hadDec && /\.00$/.test(s)) s = s.slice(0, -3);
        var sParts = s.split('.');
        sParts[0] = sParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return txt.replace(mm[0], sParts.join('.'));
      };
      priceTxt = ciScaleByQty(priceTxt);
      compareTxt = ciScaleByQty(compareTxt);
      /* 2026-09-02: an automatic promo ("EXTRA 30% OFF at checkout") is applied
         by Shopify on the cart LINE, so the row must be painted at the
         discounted price or it visibly re-prices when the render lands
         (measured: 524.00 painted, 366.80 rendered). The promo snippet only
         renders for products inside the promo collection, so its presence is
         the eligibility test and its text carries the percentage. */
      var promoLine = '';
      try {
        var promoEl = document.querySelector('[data-sale-promo]');
        var promoMsg = promoEl && promoEl.querySelector('[data-sale-msg]');
        var promoTxt = promoEl ? ((promoMsg && promoMsg.getAttribute('data-msg-full')) || promoEl.textContent || '') : '';
        var pm = promoTxt.match(/(\d{1,2})\s*%\s*off/i);
        /* 2026-09-02 (Ondrej: paint everything as if it was already added):
           the promo line in the cart ("SALE: 30% OFF AT CHECKOUT") is Shopify's
           automatic discount title. We learn it from rendered cart lines
           (cached per session, see applyParityText) and use it when the PDP
           carries no promo snippet but the product is sale-eligible (Liquid
           flag from ci-sale-flag) or was already seen discounted. */
        var cached = null;
        try { cached = JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null; } catch (ce) { cached = window.__ciPromoDefault || null; }
        var handle = (meta.product && meta.product.handle) || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
        var eligible = !!pm || window.__ciSaleEligible === true || (cached && cached.handles && cached.handles[handle]);
        if (!pm && cached && cached.pct && eligible) pm = [null, String(cached.pct)];
        var promoTitle = (cached && cached.title) || (pm ? 'SALE: ' + pm[1] + '% OFF AT CHECKOUT' : '');
        if (eligible && promoTitle) promoLine = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + String(promoTitle).replace(/</g, '&lt;') + '</li></ul>';
        var m0 = priceTxt.match(/[0-9][0-9.,]*/);
        /* Theme rule (mini-cart.liquid): a line shows compare + discounted final
           price only when the variant HAS a compare-at price; otherwise it shows
           the original price alone (the discount still applies at checkout). Paint
           the same. */
        if (pm && m0 && compareTxt) {
          var pct = parseInt(pm[1], 10);
          var base = parseFloat(m0[0].replace(/,/g, '')) || 0;
          if (pct > 0 && pct < 100 && base) {
            var parts = (base * (1 - pct / 100)).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            priceTxt = priceTxt.replace(m0[0], parts.join('.'));
          }
        }
      } catch (e) {}
      if (typeof promoTitle === 'undefined') { var promoTitle = ''; }
      /* money waits for the server render (top of file) */
      if (window.__ciEstimateMoney !== true) { promoLine = ''; priceTxt = ''; compareTxt = ''; }
      var esc = function (t) { return String(t).replace(/</g, '&lt;'); };

      /* v3: if this variant already has a line, the server will MERGE —
         painting a second row caused a visible collapse (Ondrej's "flick").
         Bump the existing row in place instead: qty up, row to top (Shopify
         renders newest-first), totals adjusted by the per-unit price.
         2026-09-21: the drawer now renders item.final_line_price, a LINE
         TOTAL, so `existingPrice` holds the PRE-BUMP LINE TOTAL. Divide it
         back out by the pre-bump quantity to recover the unit, then scale
         both the row's own text and the totals delta from that unit. Reading
         it as a unit price double-counted quantity and left the row showing
         its old total until the server render landed. */
      var existingPrice = mc.querySelector('cart-items .igPrice[data-variant-id="' + vid + '"]');
      if (existingPrice) {
        var exRow = existingPrice.closest('li');
        var exInput = exRow && exRow.querySelector('.quantity__input');
        if (exRow && exInput) {
          /* Cart V4 grouping 2026-09-21: existingPrice's text is the
             GROUP's line total now (groupFinalTotal), not one Shopify
             line's. Re-derive the unit as groupFinalTotal / groupQty using
             li.dataset.quantity (the group total the row was RENDERED
             with), not exInput.value -- the quantity-input can diverge from
             the group total while a stepper change is still in flight (see
             the 'change' interception in the OPTIMISTIC QTY/REMOVE IIFE
             below). Fall back to the input for a row without the attribute
             (should not happen post-grouping, kept defensive). */
          var exOldQty = parseInt(exRow.dataset.quantity, 10);
          if (!exOldQty) exOldQty = parseInt(exInput.value, 10) || 0;
          var exNewQty = exOldQty + qty;
          exInput.value = exNewQty;
          exRow.dataset.quantity = String(exNewQty);
          exRow.classList.add('ci-opt-pulse');
          var exList = exRow.parentNode;
          if (exList && exList.firstChild !== exRow) exList.insertBefore(exRow, exList.firstChild);
          /* local copies: a helper defined in one IIFE is undefined in the
             next, which this file has been bitten by before. */
          var exFmt = function (v, template) {
            var hadDec = /\d[.]\d{2}/.test(template || '');
            if (v < 0) v = 0;
            var st = v.toFixed(2);
            if (!hadDec && /\.00$/.test(st)) st = st.slice(0, -3);
            var pp = st.split('.');
            pp[0] = pp[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return pp.join('.');
          };
          var exWrite = function (el, v) {
            if (!el) return;
            var h = el.innerHTML, mm = h.match(/[0-9][0-9.,]*/);
            if (mm) el.innerHTML = h.replace(mm[0], exFmt(v, mm[0]));
          };
          var exNum = function (t) { return parseFloat(String(t).replace(/[^0-9.]/g, '')) || 0; };
          var exLineSale = exNum(existingPrice.textContent || '');
          var compEl2 = exRow.querySelector('.ci-compare-price, .cart-item__discounted-prices .price--on-sale price-money bdi, s.igComparePrice price-money bdi');
          var exLineComp = compEl2 ? (exNum(compEl2.textContent) || exLineSale) : exLineSale;
          var unit = exOldQty ? (exLineSale / exOldQty) : exLineSale;
          var unitComp2 = exOldQty ? (exLineComp / exOldQty) : exLineComp;
          if (window.__ciEstimateMoney === true) {
            exWrite(existingPrice.querySelector('price-money bdi') || existingPrice, unit * exNewQty);
            if (compEl2) exWrite(compEl2, unitComp2 * exNewQty);
          } else {
            existingPrice.classList.add('ci-money-pending');
            if (compEl2) compEl2.classList.add('ci-money-pending');
          }
          if (window.__ciAdjustTotals) window.__ciAdjustTotals(unit * qty, unitComp2 * qty, qty);
          mc.classList.add('ci-optimistic-pending');
          revealRow(exRow);
          armWatchdog();
          return;
        }
      }

      var row = document.createElement('li');
      row.className = 'ci-optimistic-row ci-opt-pulse';
      row.innerHTML =
        '<div class="product-container">' +
          (img ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + img + '" alt="" width="70" style="width:100%;display:block;"></span></div>' : '') +
          '<div class="product-description">' +
            '<div class="product-content"><span class="link product-title">' + esc(title) + '</span></div>' +
            (variantTitle ? '<dl><div class="product-option"><dd>' + esc(variantTitle) + '</dd></div></dl>' : '') +
            promoLine +
            '<div class="product-quantity">' +
              '<dt><quantity-input class="quantity">' +
                '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
                '<input class="quantity__input" type="text" value="' + qty + '" readonly aria-label="Quantity">' +
                '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
              '</quantity-input></dt>' +
              ((compareTxt && esc(compareTxt)) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice" data-variant-id="' + vid + '"><price-money><bdi>' + (compareTxt && esc(compareTxt)) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice" data-variant-id="' + vid + '"><price-money><bdi>' + (esc(priceTxt)) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice" data-variant-id="' + vid + '"><price-money><bdi>' + (esc(priceTxt)) + '</bdi></price-money></dd>') +
            '</div>' +
          '</div>' +
          '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
        '</div>';

      mc.classList.remove('is-empty');
      mc.classList.add('ci-optimistic-pending');
      var listEl = null;
      var ci = mc.querySelector('cart-items');
      if (ci) listEl = ci.querySelector('.mini-cart__navigation');
      /* Totals for a NEW line (the merge path already did this): without it
         the first add showed "Subtotal $0" and a stale free-shipping line. */
      try {
        var newUnit = parseFloat(String(priceTxt).replace(/[^0-9.]/g, '')) || 0;
        var newComp = parseFloat(String(compareTxt).replace(/[^0-9.]/g, '')) || newUnit;
        if (newUnit && window.__ciAdjustTotals) {
          window.__ciAdjustTotals(newUnit * qty, newComp * qty, qty);
        }
      } catch (e) {}

      window.__ciPendingRowHTML = row.outerHTML;
      if (listEl) {
        listEl.insertBefore(row, listEl.firstChild);
        revealRow(row);
      } else {
        var ul = document.createElement('ul');
        ul.className = 'mini-cart__navigation ci-optimistic-list';
        ul.appendChild(row);
        var hdr = mc.querySelector('.mini-cart__header');
        if (hdr && hdr.parentNode) hdr.insertAdjacentElement('afterend', ul);
        else mc.insertBefore(ul, mc.firstChild);
      }
      armWatchdog();
    } catch (e) { /* optimistic layer must never interfere with the real add */ }
  }
  /* Fired from BOTH paths: a real form submit, and a click on any add button
     (the sticky PDP bar's button lives OUTSIDE the product form and submits
     it programmatically, so no submit event reaches this listener in time —
     Ondrej 2026-08-31). The in-flight guard inside makes the double call
     harmless. */
  document.addEventListener('submit', function (ev) { ciOptimisticAdd(ev.target); }, true);
  document.addEventListener('click', function (ev) {
    try {
      var btn = ev.target.closest && ev.target.closest('button[name="add"], .product-form__submit');
      if (!btn || btn.disabled || btn.hasAttribute('data-sticky-notify')) return;
      var form = btn.closest('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]:not([id*="installment"])');
      if (form) ciOptimisticAdd(form);
    } catch (e) {}
  }, true);
})();

/* ---------- OPTIMISTIC QTY / REMOVE (2026-08-28, Ondrej) ----------
   Same philosophy as optimistic ATC: never touch the theme's real
   /cart/change flow; on a stepper click or trash click, instantly repaint
   the derived numbers (line price, subtotal, CTA total, item count,
   free-shipping remaining) or hide the row. The real section render
   reconciles ~1s later and is always authoritative. All string-money math
   is display-only and tolerant of both "$1,159.20" and "1,159.20 ฿". */
(function () {
  function parseMoney(str) {
    var n = String(str || '').replace(/[^0-9.]/g, '');
    return parseFloat(n) || 0;
  }
  function fmtNum(v, template) {
    var hadDec = /\d[.]\d{2}/.test(template || '');
    if (v < 0) v = 0;
    var s = v.toFixed(2);
    if (!hadDec && /\.00$/.test(s)) s = s.slice(0, -3);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function replaceAmount(el, newVal) {
    if (!el) return;
    var html = el.innerHTML;
    var m = html.match(/[0-9][0-9.,]*/);
    if (!m) return;
    el.innerHTML = html.replace(m[0], fmtNum(newVal, m[0]));
  }
  function adjustTotals(deltaSale, deltaCompare, deltaCount) {
    var mc = document.querySelector('.mini-cart');
    if (!mc) return;
    /* money waits for the server render (top of file): dim the subtotal,
       its struck compare, the savings chip and the band's amount, and leave
       their values alone. The render replaces these nodes, which clears it. */
    if (window.__ciEstimateMoney !== true) {
      mc.querySelectorAll('.subtotal .value, .subtotal [class*="save"], .button-container button[name="checkout"] .price, .free-shipping__text').forEach(function (el) {
        el.classList.add('ci-money-pending');
      });
      return;
    }
    /* subtotal (sale + struck compare) */
    var sub = mc.querySelector('.subtotal .value');
    if (sub) {
      var comp = sub.querySelector('.ci-subtotal-compare');
      var compVal = comp ? parseMoney(comp.textContent) + deltaCompare : 0;
      var saleTxt = sub.childNodes[0] && sub.childNodes[0].nodeType === 3 ? sub.childNodes[0].nodeValue : sub.textContent;
      var saleVal = parseMoney(comp ? saleTxt : sub.textContent) + deltaSale;
      if (sub.childNodes[0] && sub.childNodes[0].nodeType === 3) {
        var t = sub.childNodes[0].nodeValue;
        var m = t.match(/[0-9][0-9.,]*/);
        if (m) sub.childNodes[0].nodeValue = t.replace(m[0], fmtNum(saleVal, m[0]));
      } else {
        replaceAmount(sub, saleVal);
      }
      if (comp) replaceAmount(comp, compVal);
    }
    /* CTA total */
    replaceAmount(mc.querySelector('.button-container button[name="checkout"] .price'), 
      parseMoney((mc.querySelector('.button-container button[name="checkout"] .price') || {}).textContent) + deltaSale);
    /* item count */
    var label = mc.querySelector('.subtotal .label');
    if (label && deltaCount) {
      var lm = label.textContent.match(/\((\d+)/);
      if (lm) {
        var n = Math.max(0, parseInt(lm[1], 10) + deltaCount);
        label.textContent = document.querySelector('.mini-cart.ci-cart-v4') ? 'Subtotal' : 'Subtotal (' + n + (n === 1 ? ' item' : ' items') + ')';
      }
    }
    /* free shipping remaining */
    var fs = mc.querySelector('.free-shipping__text:not(.free-shipping__text--success)');
    if (fs) {
      var amt = fs.querySelector('.price bdi') || fs.querySelector('.price') || fs.querySelector('b');
      if (amt && /[0-9]/.test(amt.textContent)) {
        replaceAmount(amt, parseMoney(amt.textContent) - deltaSale);
      }
    }
  }
  function lineNumbers(li) {
    /* 2026-09-21: sale/comp are now LINE TOTALS, not unit prices — this
       theme renders item.final_line_price / the qty-scaled compare-at
       (mini-cart.liquid, Ondrej: "in cart ... item prices ... total, not
       per unit"), so a line's price display DOES change with quantity.
       Divide by .qty to recover the per-unit price when you need one. */
    /* Cart V4 grouping 2026-09-21: a row can now be several merged Shopify
       lines rendered as one <li>. li.dataset.quantity is the GROUP total
       (Liquid renders it as ci_g_qty and the stepper interception below
       keeps it current across changes); the quantity-input's own value can
       briefly hold the PRIMARY line's post-change quantity instead (see the
       'change' interception further down), so prefer the dataset when a row
       carries it and only fall back to the input for rows that don't
       (synthetic optimistic rows have no data-quantity attribute). */
    var qtyInput = li.querySelector('.quantity__input');
    var qty;
    if (li.dataset.quantity !== undefined) {
      qty = parseInt(li.dataset.quantity, 10) || 0;
    } else {
      qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }
    var saleEl = li.querySelector('.cart-item__discounted-prices dd.price:not(.price--on-sale) price-money bdi, dd.price price-money bdi');
    var compEl = li.querySelector('.cart-item__discounted-prices .price--on-sale price-money bdi, .ci-compare-price');
    var sale = saleEl ? parseMoney(saleEl.textContent) : 0;
    var comp = compEl ? parseMoney(compEl.textContent) : sale;
    return { qty: qty, sale: sale, comp: comp, saleEl: saleEl, compEl: compEl };
  }
  window.__ciAdjustTotals = adjustTotals;

  /* ---- 2026-09-21 grouped-row stepper math (Ondrej: BOGO free units get
     their own row) ----
     mini-cart.liquid now renders ONE <li> per (variant_id, unit final price)
     GROUP, so the quantity-input DISPLAYS the group total (li.dataset.quantity)
     while its own data-index/value still target the PRIMARY member (the
     group's largest-quantity line), whose own quantity is smaller. Posting
     the displayed value directly would over-set that one line. Intercept the
     change in capture phase -- before the theme's own change handler
     (bound on an ancestor, not capture) reads input.value -- and rewrite it
     to the primary line's new quantity. data-index is already correct
     (Liquid renders it from the primary member), so the theme's existing
     /cart/change flow posts the right thing without anything else changing.
     Shopify re-splits the lines after every change, so only the resulting
     TOTAL has to be right.
     li.dataset.quantity / data-primary-qty are kept in sync with what we
     just posted (not explicitly specified by the spec, but required so a
     SECOND change before the next render still computes its delta against
     the latest state instead of the stale server-rendered numbers). */
  document.addEventListener('change', function (ev) {
    try {
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      var input = ev.target;
      if (!input || !input.matches || !input.matches('.mini-cart cart-items .quantity__input')) return;
      var li = input.closest('li');
      if (!li || li.dataset.primaryQty === undefined) return;
      var oldGroupQty = Number(li.dataset.quantity) || 0;
      var oldPrimaryQty = Number(li.dataset.primaryQty) || 0;
      var newDisplayedValue = Number(input.value) || 0;
      var delta = newDisplayedValue - oldGroupQty;
      var primaryNewQty = oldPrimaryQty + delta;
      if (primaryNewQty < 0) primaryNewQty = 0;
      var appliedDelta = primaryNewQty - oldPrimaryQty;
      /* 2026-09-23, Ondrej: "when I'm decreasing quantity using the stepper,
         it flickers at 1 every time". This used to write primaryNewQty into
         the VISIBLE input, which the shopper saw for the theme's 300ms
         debounce + the /cart/change round trip (a BOGO-split row's primary
         line is often qty 1). The box now keeps the group total; the
         translation to the primary line happens at post time in the
         CartItems.onChange wrap below. Only a clamp touches the box. */
      if (appliedDelta !== delta) input.value = String(oldGroupQty + appliedDelta);
      li.dataset.quantity = String(oldGroupQty + appliedDelta);
      li.dataset.primaryQty = String(primaryNewQty);
    } catch (e) { /* never block the native change flow */ }
  }, true);
  /* Post the primary line's quantity (accumulated in data-primary-qty by the
     capture handler above, once per click, so a debounced burst of clicks
     posts the right total). Wraps onChange, not updateQuantity, because
     cart-remove-button also calls updateQuantity(index, 0). */
  if (window.customElements) customElements.whenDefined('cart-items').then(function () {
    try {
      var CI = customElements.get('cart-items');
      if (!CI || CI.prototype.__ciGroupWrapped) return;
      var origOnChange = CI.prototype.onChange;
      CI.prototype.onChange = function (event) {
        try {
          var t = event && event.target;
          var li = t && t.matches && t.matches('.mini-cart cart-items .quantity__input') && t.closest('li');
          if (li && li.dataset.primaryQty !== undefined && document.documentElement.classList.contains('ci-native-cart')) {
            return this.updateQuantity(t.dataset.index, li.dataset.primaryQty, document.activeElement && document.activeElement.getAttribute('name'));
          }
        } catch (e) {}
        return origOnChange.apply(this, arguments);
      };
      CI.prototype.__ciGroupWrapped = true;
    } catch (e) {}
  });

  /* 2026-09-02 reliability pass: a remove / qty change whose /cart/change
     request fails used to leave the row dimmed-and-spinning forever with
     the totals already adjusted. The theme's own catch path re-hides its
     .loading-overlay WITHOUT rendering, which is our failure signal; a 9s
     watchdog backstops a request that never returns at all. Both hand off
     to the shared reconcile (clear optimistic state, re-pull the drawer,
     one-line note). */
  var rmTimer = null;
  function armRemoveWatchdog() {
    clearTimeout(rmTimer);
    rmTimer = setTimeout(function () {
      if (document.querySelector('.mini-cart .ci-opt-removing, .mini-cart .ci-opt-qtying') && window.__ciReconcile) {
        window.__ciReconcile("Your cart didn't update. Please try again.");
      }
    }, 9000);
  }
  document.addEventListener('ci:cart:rerendered', function () { clearTimeout(rmTimer); });
  (function watchOverlay() {
    var host = document.getElementById('mini-cart');
    if (!host || typeof MutationObserver === 'undefined') return;
    /* read-only on the observed subtree except through reconcile, which only
       runs on a failure and immediately clears the state it keys on */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!t || !t.classList || !t.classList.contains('loading-overlay') || !t.classList.contains('hidden')) continue;
        var row = t.closest && t.closest('.ci-opt-removing, .ci-opt-qtying');
        if (row && window.__ciReconcile) {
          setTimeout(function () {
            if (Date.now() - (window.__ciLastRenderAt || 0) < 700) return;   /* render landed */
            if (!document.querySelector('.mini-cart .ci-opt-removing, .mini-cart .ci-opt-qtying')) return;
            window.__ciReconcile("Your cart didn't update. Please try again.");
          }, 250);
          return;
        }
      }
    }).observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
  })();

  document.addEventListener('click', function (ev) {
    try {
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;

      /* ---- remove ---- */
      var rm = ev.target.closest && ev.target.closest('.mini-cart cart-remove-button');
      if (rm) {
        var li = rm.closest('li');
        /* 2026-09-22, Ondrej: "grey out X on free product". The CSS greys it
           off li[data-free="true"] and drops pointer-events, but a keyboard
           activation still reaches this handler, so refuse here too. The row
           keeps the control's shape, not its action; minus stays live. Why it
           cannot act: BOGO is cart-wide, so removing a free line is not a
           local edit (6 units -> the row returns at qty 1; mixed cart -> the
           free-ness hops to a sibling unit). See the comment block above
           cart-remove-button in sections/mini-cart.liquid for the measurements. */
        if (li && li.getAttribute('data-free') === 'true') {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          return;
        }
        if (li && !li.classList.contains('ci-opt-removed')) {
          var n = lineNumbers(li);
          li.classList.add('ci-opt-removed');
          /* Ondrej 2026-08-31: instant-hide plus a frozen second read as a
             glitch. Keep the row visible but dimmed and pulsing with a
             spinner over the trash until the real render drops it. */
          li.classList.add('ci-opt-removing');
          armRemoveWatchdog();
          /* 2026-09-21 FIX. This block still multiplied by n.qty under the
             comment "unit price x qty", but lineNumbers() has returned LINE
             TOTALS since the line-total change earlier today (see its own
             header comment): n.sale is already the whole row. Multiplying
             again subtracted qty times too much, so removing the 3-pyramid
             row optimistically took 70.35 x 3 = 211.05 off an 89.80
             subtotal until the server render landed and corrected it.
             The tracking value was wrong the same way, and that one does
             NOT get corrected by a re-render: ci_cart_remove was reporting
             a line value of 211.05 for a 70.35 row. Subtract the totals as
             they are. */
          try { window.__ciTrack && window.__ciTrack('ci_cart_remove', { ci_qty: n.qty, ci_line: Math.round(n.sale * 100) / 100, ci_items: mc.querySelectorAll('cart-items li').length }); } catch (te) {}
          adjustTotals(-n.sale, -n.comp, -n.qty);

          /* Cart V4 grouping 2026-09-21: a merged row maps to SEVERAL
             Shopify line keys (li.dataset.lineKeys). The stock remove
             control (this element's own href / click handling) only ever
             targets ONE line, which would leave the row's other members in
             the cart. Take the removal over ourselves: block the native
             path (it would fire on the same click, on the anchor's href or
             the custom element's own listener) and zero every key in one
             request. */
          ev.preventDefault();
          ev.stopImmediatePropagation();
          /* 2026-09-22 X-BUTTON FIX (Ondrej: "sometimes I tap it and it
             doesn't remove all the pieces, happens when there is like three
             plus pieces of an item"). data-line-keys is this GROUP's keys
             (variant_id + final_price). Under BOGO one variant sits in TWO
             groups, so that attribute left the free line in the cart and
             Shopify re-priced it: measured, 3 units, tap X on the paid row,
             ONE UNIT LEFT AT FULL PRICE. data-all-keys carries every key of
             the variant. The single atomic update below is required, not a
             style choice: sequential per-key calls fail because each write
             re-keys the surviving lines, and updates keyed by variant id zero
             only one of the split lines. Verified at 3/6/7/9 units and mixed. */
          var lineKeysAttr = li.getAttribute('data-all-keys') || li.getAttribute('data-line-keys');
          var rmKeys = lineKeysAttr ? lineKeysAttr.split(',').filter(Boolean) : [];
          if (rmKeys.length) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: Object.fromEntries(rmKeys.map(function (k) { return [k, 0]; })) })
            })
              .then(function () { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); })
              .catch(function () { if (window.__ciReconcile) window.__ciReconcile("Your cart didn't update. Please try again."); });
          }
        }
        return;
      }

      /* ---- drawer recommendation ADD: paint the new line instantly ---- */
      var recAdd = ev.target.closest && ev.target.closest('.mini-cart cart-recommendations add-to-cart');
      if (recAdd) {
        var recVid = recAdd.getAttribute('data-variant-id');
        try {
          var recLi = recAdd.closest('li');
          var T = window.__ciTrack;
          if (T && recLi) {
            var rf = { ci_surface: 'drawer', ci_host: recLi.getAttribute('data-rec-host') || '', ci_candidate: recLi.getAttribute('data-rec-candidate') || '',
              ci_rank: recLi.getAttribute('data-rec-rank') || '', ci_pos: recLi.getAttribute('data-rec-pos') || '', ci_intent: recLi.getAttribute('data-rec-intent') || '',
              ci_variant: String(recVid || ''), ci_chooser: recLi.querySelector('.ci-rec-variant') ? 1 : 0 };
            T('ci_rec_add', rf);
            T('ci_cart_add', { ci_source: 'drawer_rec', ci_product: rf.ci_candidate, ci_variant: rf.ci_variant, ci_qty: 1 });
          }
        } catch (te) {}
        var recExisting = recVid ? mc.querySelector('cart-items .igPrice[data-variant-id="' + recVid + '"]') : null;
        if (recExisting) {
          var rRow = recExisting.closest('li');
          var rInput = rRow && rRow.querySelector('.quantity__input');
          if (rRow && rInput) {
            /* Cart V4 grouping 2026-09-21: same re-derivation as the PDP
               merge branch above -- prefer li.dataset.quantity (the group
               total) over rInput.value, which can diverge from it while a
               stepper change is in flight. */
            var rOldQty = parseInt(rRow.dataset.quantity, 10);
            if (!rOldQty) rOldQty = parseInt(rInput.value, 10) || 0;
            var rNewQty = rOldQty + 1;
            rInput.value = rNewQty;
            rRow.dataset.quantity = String(rNewQty);
            rRow.classList.add('ci-opt-pulse');
            if (rRow.parentNode && rRow.parentNode.firstChild !== rRow) rRow.parentNode.insertBefore(rRow, rRow.parentNode.firstChild);
            /* 2026-09-21: same line-total correction as the PDP merge branch
               above. These elements hold the PRE-BUMP LINE TOTAL now, so
               divide by the old quantity before scaling, and rewrite the
               row's own text or it keeps the stale total on screen. */
            var rLineSale = parseMoney(recExisting.textContent);
            var rCompEl = rRow.querySelector('.ci-compare-price, .cart-item__discounted-prices .price--on-sale price-money bdi, s.igComparePrice price-money bdi');
            var rLineComp = rCompEl ? parseMoney(rCompEl.textContent) : rLineSale;
            var rUnit = rOldQty ? (rLineSale / rOldQty) : rLineSale;
            var rUnitComp = rOldQty ? (rLineComp / rOldQty) : rLineComp;
            if (window.__ciEstimateMoney === true) {
              replaceAmount(recExisting.querySelector('price-money bdi') || recExisting, rUnit * rNewQty);
              if (rCompEl) replaceAmount(rCompEl, rUnitComp * rNewQty);
            } else {
              recExisting.classList.add('ci-money-pending');
              if (rCompEl) rCompEl.classList.add('ci-money-pending');
            }
            adjustTotals(rUnit, rUnitComp, 1);
          }
          return;
        }
        var rec = recAdd.closest('.ci-rec');
        var listEl = mc.querySelector('cart-items .mini-cart__navigation');
        if (rec && listEl) {
          var rTitle = (rec.querySelector('.product-title') || {}).textContent || '';
          var rImg = (rec.querySelector('.product-image img') || {}).currentSrc || '';
          var rSaleEl = rec.querySelector('.ci-rec-price__sale');
          var rCompEl = rec.querySelector('.ci-rec-price__was');
          var rSale = rSaleEl ? parseMoney(rSaleEl.textContent) : 0;
          var rComp = rCompEl ? parseMoney(rCompEl.textContent) : rSale;
          /* 2026-09-02: paint the SALE line too (Ondrej: everything as if already
             added). Eligibility comes from the row (data-rec-sale, same collection
             rule as the PDP flag); the title is the automatic discount's, learned
             from rendered lines earlier in the session. */
          var rPromo = '', rPct = 0;
          try {
            var rLi = rec.closest('li');
            var rc = window.__ciEstimateMoney === true ? (JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null) : null;
            if (rLi && rLi.getAttribute('data-rec-sale') === '1' && rc && rc.title) { rPromo = rc.title; rPct = parseInt(rc.pct, 10) || 0; }
          } catch (pe) {}
          var rSaleTxt = rSaleEl ? rSaleEl.textContent.trim() : '';
          var rCompTxt = rCompEl ? rCompEl.textContent.trim() : '';
          if (rPct > 0 && rPct < 100 && rCompEl && rSale) {
            /* same rule as the PDP path: discounted final price only next to a compare-at */
            var rm0 = rSaleTxt.match(/[0-9][0-9.,]*/);
            if (rm0) {
              var rParts = (rSale * (1 - rPct / 100)).toFixed(2).split('.');
              rParts[0] = rParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              rSaleTxt = rSaleTxt.replace(rm0[0], rParts.join('.'));
              rSale = rSale * (1 - rPct / 100);
            }
          }
          /* money waits for the server render (top of file) */
          if (window.__ciEstimateMoney !== true) { rPromo = ''; rSaleTxt = ''; rCompTxt = ''; }
          var rOptSel = rec.querySelector('.ci-rec-variant');
          var rOptTxt = rOptSel && rOptSel.options[rOptSel.selectedIndex] ? rOptSel.options[rOptSel.selectedIndex].textContent.trim() : '';
          var li2 = document.createElement('li');
          li2.className = 'ci-optimistic-row ci-opt-pulse';
          /* 2026-08-31: this row still used the v1 "Qty 1 <price>" markup, so
             a drawer-upsell add looked nothing like a main-ATC add (Ondrej's
             screenshot: price on the left, no stepper). Same clone structure
             as every other optimistic row now. */
          li2.innerHTML =
            '<div class="product-container">' +
              (rImg ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + rImg + '" alt="" style="width:100%;display:block;"></span></div>' : '') +
              '<div class="product-description">' +
                '<div class="product-content"><span class="link product-title">' + rTitle.replace(/</g, '&lt;').trim() + '</span></div>' +
                (rOptTxt ? '<dl><div class="product-option"><dd>' + rOptTxt.replace(/</g, '&lt;') + '</dd></div></dl>' : '') +
                (rPromo ? '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + rPromo.replace(/</g, '&lt;') + '</li></ul>' : '') +
                '<div class="product-quantity">' +
                  '<dt><quantity-input class="quantity">' +
                    '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
                    '<input class="quantity__input" type="text" value="1" readonly aria-label="Quantity">' +
                    '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
                  '</quantity-input></dt>' +
                  ((rCompTxt) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rCompTxt) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rSaleTxt) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rSaleTxt) + '</bdi></price-money></dd>') +
                '</div>' +
              '</div>' +
              '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
            '</div>';
          listEl.insertBefore(li2, listEl.firstChild);
          adjustTotals(rSale, rComp, 1);
          setTimeout(function () { if (li2.parentNode) li2.remove(); }, 12000);
        }
        return;
      }

      /* ---- checkout ---- */
      var co = ev.target.closest && ev.target.closest('.mini-cart button[name="checkout"], .mini-cart a[href*="/checkout"]');
      if (co) {
        try {
          var coPrice = mc.querySelector('.button-container button[name="checkout"] .price');
          window.__ciTrack && window.__ciTrack('ci_cart_checkout', { ci_items: mc.querySelectorAll('cart-items li').length,
            ci_subtotal: coPrice ? parseMoney(coPrice.textContent) : 0,
            ci_secs_open: window.__ciCartOpenedAt ? Math.round((Date.now() - window.__ciCartOpenedAt) / 1000) : 0 });
        } catch (te) {}
        return;
      }

      /* ---- qty stepper ---- */
      var btn = ev.target.closest && ev.target.closest('.mini-cart cart-items .quantity__button');
      if (btn) {
        var row = btn.closest('li');
        if (!row) return;
        var before = lineNumbers(row);
        /* same feedback language as removal (Ondrej 2026-08-31): pulse the
           row + spin a ring by the stepper until the render confirms. Kept
           clickable so rapid +/- still works. */
        row.classList.add('ci-opt-qtying');
        armRemoveWatchdog();
        setTimeout(function () {
          try {
            var after = lineNumbers(row);
            var delta = after.qty - before.qty;
            if (!delta) return;
            /* 2026-09-21: before.sale/before.comp are LINE TOTALS for the
               PRE-click qty (see the doc comment on lineNumbers). Recover the
               stored UNIT price by dividing the qty back out, then rewrite
               the row's own price text as unit x new qty -- the price
               display is no longer flat across a qty change. */
            var unitSale = before.sale / (before.qty || 1);
            var unitComp = before.comp / (before.qty || 1);
            try { window.__ciTrack && window.__ciTrack('ci_cart_qty', { ci_from: before.qty, ci_to: after.qty, ci_unit: unitSale }); } catch (te) {}
            if (window.__ciEstimateMoney === true) {
              if (before.saleEl) replaceAmount(before.saleEl, unitSale * after.qty);
              if (before.compEl) replaceAmount(before.compEl, unitComp * after.qty);
            } else {
              if (before.saleEl) before.saleEl.classList.add('ci-money-pending');
              if (before.compEl) before.compEl.classList.add('ci-money-pending');
            }
            /* totals still move by the per-unit price x the qty delta */
            adjustTotals(unitSale * delta, unitComp * delta, delta);
          } catch (e) {}
        }, 0);
      }
    } catch (e) { /* display-only layer; the real render reconciles */ }
  }, true);
})();

/* ---- 2026-09-23 picks strip: desktop scroll arrows ----
   Ondrej: "add a gentle orchid arrow to the right in the upsell widget on
   desktop, so it's obvious one can scroll through it or click through it,
   because on desktop you cannot swipe. On mobile don't add the same."
   One cream disc with an orchid chevron at the strip's right edge, shown only
   while there is more to the right; a matching left disc appears once the
   strip has moved, or a mouse user could not get back. Visibility is CSS-gated
   to (hover: hover) and (pointer: fine), so touch devices never see them.
   Covers both strips: the filled cart's <cart-recommendations> and the empty
   cart's best sellers. The drawer re-renders its whole section on every cart
   change, so the discs are (re)attached from a childList-only observer on
   #mini-cart; ensure() only ever INSERTS when a disc is missing, so its own
   insert finds them present on the next pass and cannot loop, and the state
   updates are attribute writes, which the observer does not watch. */
(function () {
  var CHEV = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function strips() {
    return document.querySelectorAll('.mini-cart.ci-cart-v4 cart-recommendations, .mini-cart.ci-cart-v4 .cart-recommendations');
  }
  function update(box) {
    var ul = box.querySelector('.mini-cart__navigation');
    if (!ul) return;
    var more = ul.scrollLeft + ul.clientWidth < ul.scrollWidth - 2;
    var prev = ul.scrollLeft > 2;
    box.classList.toggle('ci-has-more', more);
    box.classList.toggle('ci-has-prev', prev);
    /* centre the discs on the 136px photos, whatever sits above the strip */
    box.querySelectorAll('.ci-strip-arrow').forEach(function (b) {
      var v = (ul.offsetTop + 68 - Math.round((b.offsetHeight || 38) / 2)) + 'px';
      if (b.style.top !== v) b.style.top = v;
    });
  }
  function ensure() {
    Array.prototype.forEach.call(strips(), function (box) {
      if (!box.querySelector('.mini-cart__navigation')) return;
      if (!box.querySelector(':scope > .ci-strip-arrow--right')) {
        ['left', 'right'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ci-strip-arrow ci-strip-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'right' ? 'More picks' : 'Previous picks');
          b.tabIndex = -1;
          b.innerHTML = CHEV;
          box.appendChild(b);
        });
      }
      update(box);
    });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.ci-strip-arrow');
    if (!b) return;
    ev.preventDefault();
    var box = b.parentElement;
    var ul = box && box.querySelector('.mini-cart__navigation');
    if (!ul) return;
    var dir = b.classList.contains('ci-strip-arrow--left') ? -1 : 1;
    /* one card is 136px + a 10px gap; move by the whole cards that fit
       minus one, so the last visible card stays as the anchor */
    var step = Math.max(146, (Math.floor(ul.clientWidth / 146) - 1) * 146);
    ul.scrollBy({ left: dir * step, behavior: 'smooth' });
    try { window.__ciTrack && window.__ciTrack('ci_rec_arrow', { ci_dir: dir > 0 ? 'right' : 'left', ci_strip: box.classList.contains('ci-empty-bestsellers') ? 'empty' : 'recommended' }); } catch (te) {}
  });
  /* scroll does not bubble; capture it for any strip */
  document.addEventListener('scroll', function (ev) {
    var ul = ev.target;
    if (!ul || !ul.classList || !ul.classList.contains('mini-cart__navigation')) return;
    var box = ul.closest('cart-recommendations, .cart-recommendations');
    if (box) update(box);
  }, true);
  window.addEventListener('resize', function () { Array.prototype.forEach.call(strips(), update); });
  var pending = null;
  function schedule() { clearTimeout(pending); pending = setTimeout(ensure, 60); }
  function start() {
    var host = document.getElementById('mini-cart');
    ensure();
    if (!host || typeof MutationObserver === 'undefined') return;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();


/* ---------- OneText SMS popup waits for the cart drawer (2026-10-13, Ondrej) ----------
   "not to send people away from the drawer": the OneText popup is a MODAL <dialog> inside
   body > #ot-popup-shadow-container, opened with showModal(). While the cart drawer is open that call is held
   and replayed once the drawer closes, so the popup opens as usual, just later; a shopper who goes from the
   drawer to checkout never sees it. Never hide an open modal instead: a hidden modal leaves the page inert
   (the 06:17-07:12Z freeze on the gift arm). Events: ci_ot_popup_deferred, ci_ot_popup_released. */
(function () {
  var D = window.HTMLDialogElement && window.HTMLDialogElement.prototype;
  if (!D || typeof D.showModal !== 'function' || D.__ciOtDefer) return;
  var orig = D.showModal;
  var held = null;
  function drawerOpen() { return !!document.querySelector('details.cart-drawer-container[open]'); }
  function isOneText(dl) {
    try { var r = dl.getRootNode(); return !!(r && r.host && r.host.id === 'ot-popup-shadow-container'); } catch (e) { return false; }
  }
  function track(n) { try { if (window.__ciTrack) window.__ciTrack(n, {}); } catch (e) {} }
  D.showModal = function () {
    if (isOneText(this) && drawerOpen()) {
      if (held !== this) track('ci_ot_popup_deferred');
      held = this;
      return;
    }
    return orig.apply(this, arguments);
  };
  D.__ciOtDefer = true;
  function release() {
    if (!held || drawerOpen()) return;
    var dl = held;
    setTimeout(function () {
      if (held !== dl || drawerOpen()) return;   /* reopened meanwhile: keep holding */
      held = null;
      if (!dl.isConnected || dl.open) return;     /* OneText dropped or already showed it */
      try { orig.call(dl); track('ci_ot_popup_released'); } catch (e) {}
    }, 600);
  }
  /* the drawer is a <details>; toggle does not bubble, so listen in the capture phase */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('cart-drawer-container')) release();
  }, true);
})();


/* ---------- threshold reach tracking (2026-10-13, Ondrej: "do we measure every reach of gift/free shipping") ----------
   Identical on MAIN and every cart arm, so the arms compare like for like: ci_tier_up / ci_tier_down with ci_tier
   'gift' ($58.85) or 'ship' ($78.85), on EVERY crossing caused by a cart change in this page (the first cart seen is
   only the baseline, so a page load never fires). USD carts only: the test is US-only and the thresholds are USD.
   Totals are the drawer's qualifying subtotal; every read is also broadcast as document event ci:cart:qual.
   Reads the cart JSON the theme already fetches (passive read of /cart.js, /cart/change, /cart/update, /cart/clear
   responses; /cart/add returns a line, not a cart, so it is skipped) and, if a cart change brings no cart JSON with
   it, makes one /cart.js call of its own. Intelligems gets these through the ciTrackBridge event. */
(function () {
  if (window.__ciTierTrack || typeof window.fetch !== 'function') return;
  window.__ciTierTrack = 1;
  var TIERS = [['gift', 5885], ['ship', 7885]];
  var CART_URL = /\/cart(\.js|\/(change|update|clear)(\.js)?)(\?|$)/;
  var last = null, seenAt = 0, timer = 0;
  function track(n, p) { try { if (window.__ciTrack) window.__ciTrack(n, p); } catch (e) {} }
  /* qualifying subtotal = the drawer bar's: non-gift lines' final_line_price (a gift line is any line with
     properties._ci_gift; control has none), so a briefly charged gift line never counts */
  function qual(c) {
    var s = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (it.properties && it.properties._ci_gift) continue;
      s += it.final_line_price || 0;
    }
    return s;
  }
  function take(c) {
    if (!c || typeof c.total_price !== 'number' || !c.items) return;
    seenAt = Date.now();
    var t = qual(c);
    try { document.dispatchEvent(new CustomEvent('ci:cart:qual', { detail: { cents: t, currency: c.currency || '' } })); } catch (e) {}
    if (c.currency && c.currency !== 'USD') { last = null; return; }
    if (last !== null && t !== last) {
      for (var i = 0; i < TIERS.length; i++) {
        var k = TIERS[i][0], v = TIERS[i][1];
        if (last < v && t >= v) track('ci_tier_up', { ci_tier: k, ci_total: t / 100 });
        else if (last >= v && t < v) track('ci_tier_down', { ci_tier: k, ci_total: t / 100 });
      }
    }
    last = t;
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_URL.test(url)) {
        p.then(function (res) {
          try { if (res && res.ok) res.clone().json().then(take, function () {}); } catch (e) {}
        }, function () {});
      }
    } catch (e) {}
    return p;
  };
  function changed() {
    var at = Date.now();
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (seenAt >= at) return;                       /* the change already brought its cart JSON */
      origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(take, function () {});
    }, 700);
  }
  document.addEventListener('ci:cart:rerendered', changed);
  document.addEventListener('cart:updated', changed);
  /* baseline if the theme has not read the cart by then */
  setTimeout(function () {
    if (last === null && !seenAt) origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(take, function () {});
  }, 4000);
})();
